import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'Pöytätilaus',
    [ORDER_METHODS.PICKUP]: 'Nouto',
    [ORDER_METHODS.DELIVERY]: 'Toimitus',
  },
};
